import type { ComponentProps } from "react"
import ChartContainer from "@/v2-ui/chart/base/ChartBaseContainer"
import cn from "../utils/utils.cn"

export type ChartProps = ComponentProps<typeof ChartContainer>

function Chart(props: ChartProps) {
  const { className, ...carouselBaseProps } = props
  return (
    <ChartContainer
      className={cn("ui_chart", className)}
      {...carouselBaseProps}
    />
  )
}

export default Chart
